import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";

import { StyledInputWrapper } from "../../Styled";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
}

export const SearchInput = ({ value, onChange }: SearchInputProps) => {
    return (
        <StyledInputWrapper>
            <Space.Compact block>
                <Input
                    size="large"
                    placeholder="Пошук за ім'ям або номером"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    allowClear
                />
                <Button size="large" icon={<SearchOutlined />} />
            </Space.Compact>
        </StyledInputWrapper>
    );
};
